<template>
  <div :class="{ 'car-details__desktop-extended': desktopExtended }">
    <h2 class="name">
      {{ name }}
    </h2>
    <template v-if="desktopExtended">
      <div v-for="detail in fullWidthDetails" :key="detail.name">
        <div class="car-details__detail car-details--desktop">
          <span class="car-details__type">{{ detail.name }}:</span>
          {{ detail.value }}
        </div>
      </div>
    </template>
    <div class="car-details">
      <div
        v-for="{ name: detailName, value, extendedInfo } in gridDetails"
        :key="detailName"
        :class="{ 'car-details--extended': extendedInfo }"
      >
        <div class="car-details__detail">
          <span class="car-details__type">{{ detailName }}:</span>
          {{ value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCarDetails",
  props: {
    desktopExtended: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ""
    },
    gearbox: {
      type: String,
      default: ""
    },
    fuel: {
      type: String,
      default: ""
    },
    mileage: {
      type: String,
      default: ""
    },
    body: {
      type: String,
      default: ""
    },
    engineSize: {
      type: String,
      default: ""
    },
    model: {
      type: String,
      default: ""
    },
    trim: {
      type: String,
      default: ""
    },
    year: {
      type: Number,
      default: 0
    },
    doors: {
      type: Number,
      default: 0
    },
    dealer: {
      type: String,
      default: ""
    },
    phone: {
      type: String,
      default: ""
    }
  },
  computed: {
    engineInfo() {
      return this.engineSize ? `${this.fuel} (${this.engineSize})` : this.fuel;
    },
    fullWidthDetails() {
      return [{ name: this.$t("shared.trim"), value: this.trim }];
    },
    gridDetails() {
      return [
        {
          name: this.$t("shared.phone"),
          value: this.phone,
          extendedInfo: true
        },
        {
          name: this.$t("shared.dealer"),
          value: this.dealer,
          extendedInfo: true
        },
        {
          name: this.$t("shared.model"),
          value: `Hyundai ${this.model}`,
          extendedInfo: true
        },
        { name: this.$t("shared.gearbox"), value: this.gearbox },
        { name: this.$t("shared.fuel"), value: this.engineInfo },
        { name: this.$t("shared.mileage"), value: this.mileage },
        { name: this.$t("shared.body"), value: this.body },
        { name: this.$t("search.year"), value: this.year, extendedInfo: true },
        { name: this.$t("shared.door"), value: this.doors, extendedInfo: true }
      ];
    }
  }
};
</script>

<style scoped lang="scss">
.name {
  margin: 0;
  color: $color-blue-300;
  font-size: $font-size-xl;
}

.car-details {
  @include grid-columns(2);
  @include grid-ie11-fix(2);

  grid-column-gap: 5px;
  margin: 18px 0;

  &--extended,
  &--desktop {
    display: none;
  }

  &__detail {
    margin: 5px 0;
  }

  &__type {
    text-transform: capitalize;
    font-weight: 700;
    color: $color-grey-400;
  }

  &__desktop-extended {
    .car-details--extended {
      display: block;
    }
  }
}

@media screen and (min-width: $media-l) {
  .car-details__desktop-extended .car-details {
    @include grid-columns(3);
    @include grid-ie11-fix(3);

    margin: 0;

    &--desktop {
      display: block;
    }

    &__detail {
      font-size: $font-size-sl;
    }

    &__type {
      text-transform: uppercase;
      display: block;
      font-size: $font-size-m;
      margin: 20px 0 5px;
    }
  }
}

@media screen and (min-width: $media-l) {
  .car-details__desktop-extended .name {
    display: none;
  }
}

@media screen and (min-width: $media-xxxl) {
  .car-details__desktop-extended .car-details {
    display: flex;
    flex-wrap: wrap;

    &__detail {
      min-width: 200px;
      padding-right: 15px;
    }
  }
}
</style>
